module.exports = "/images/settings-icon.svg?775a5cb712140ee1f259bd5676f6afc9";